export default "__VITE_PUBLIC_ASSET__938b9b02__"